import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { EAdAccountPlatform } from "@/types";
import { LuArrowRight } from "react-icons/lu";
import { cn } from "@/lib/utils";
import { SUPPORTED_PLATFORMS } from "./AccountsDropdown";

const ADD_ACCOUNT_DIALOG_BUTTON_TEXT = "Connect";
const ADD_ACCOUNT_DIALOG_TITLE = "Start by Adding Your Brand";
const ADD_ACCOUNT_DISABLED_TEXT = "Coming soon";
const DIALOG_DESCRIPTION = "Select a platform to connect your ad account ";
const EMPTY_ACCOUNT_HEADER = "Start by adding your Ad accounts";

export default function AddAccountDialog({
  open,
  onOpenChange,
  onConfirm,
  isDialog = true,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (platform: EAdAccountPlatform) => Promise<void>;
  isDialog?: boolean;
}) {
  const getDialogContent = () => {
    return (
      <div
        className={cn(
          "grid grid-cols-2 gap-[16px] mb-[30px]",
          isDialog && "mx-[80px] px-[20px]",
        )}
      >
        {SUPPORTED_PLATFORMS.map((platform) => (
          <div
            key={platform.platform}
            className="flex flex-col gap-[24px] border-[1px] border-border-gray rounded-[6px] pt-[24px] pb-[18px] px-[20px] w-[165px] h-[165px]"
          >
            <div className="flex flex-col gap-[8px] font-[500] text-[16px] text-brand-primary-new">
              <img src={platform.icon} className="w-[24px] h-[24px] object-contain" />
              <span>
                {platform.name.charAt(0).toUpperCase() + platform.name.slice(1)}
              </span>
            </div>
            <Button
              variant="outline"
              onClick={() => {
                if (platform.enabled) {
                  void onConfirm(platform.platform);
                } else {
                  return;
                }
              }}
              className={cn(
                "w-fit rounded-[4px] inline-flex items-center gap-[6px] px-[14px] py-[6px] font-[500] text-brand-primary-new text-[12px] border-[1px] shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]",
                platform.enabled
                  ? "border-border-gray"
                  : " text-brand-primary-600 border-border-gray/60",
              )}
              disabled={!platform.enabled}
            >
              <span>
                {platform.enabled
                  ? ADD_ACCOUNT_DIALOG_BUTTON_TEXT
                  : ADD_ACCOUNT_DISABLED_TEXT}
              </span>
              &nbsp;
              {platform.enabled && <LuArrowRight size={14} />}
            </Button>
          </div>
        ))}
      </div>
    );
  };
  return (
    <>
      {isDialog ? (
        <Dialog open={open} onOpenChange={onOpenChange}>
          <DialogContent
            className="max-w-max gap-0"
            closeIconClassName="h-[24px] w-[24px]"
          >
            <DialogHeader className="!text-center mt-[32px]">
              <DialogTitle className="text-brand-primary-new text-[18px] font-[500] leading-normal tracking-[-0.18px]">
                {ADD_ACCOUNT_DIALOG_TITLE}
              </DialogTitle>
            </DialogHeader>
            <DialogDescription className="mt-[9px] mb-[32px] text-[#617390] text-center text-[16px] font-[400]">
              {DIALOG_DESCRIPTION}
            </DialogDescription>
            {getDialogContent()}
          </DialogContent>
        </Dialog>
      ) : (
        <div className="flex flex-col flex-grow items-center justify-center gap-[8px]">
          <div className="text-[18px] text-brand-primary-new font-500">
            {EMPTY_ACCOUNT_HEADER}
          </div>
          <div className="text-[16px] text-[#617390] font-400">{DIALOG_DESCRIPTION}</div>
          <div className="mt-[32px]">{getDialogContent()}</div>
        </div>
      )}
    </>
  );
}
